import api from '../api';

const getJobProgress = async (requestId) => {
    const { data } = await api.get(`admin/job/progress-request/${requestId}`, {
        params: {
            unpaged: true
        }
    });
    return data;
};

const getJob = async (requestId) => {
    const data = await api.get(`admin/job/result-request-file-data/${requestId}`, {
        params: {
            unpaged: true
        }
    });
    return data;
};

const JobProgressService = {
    getJobProgress,
    getJob
};

export default JobProgressService;
